<template>
    <div class="card task-list" :style="height && `height: ${height - 10}px;`">
        <div class="card-body row p-0 m-0">
            <div class="col-12 p-0 table-responsive">
                <el-table class="table-striped"
                          :height="height ? height - 10 : '100%'"
                          header-row-class-name="text-primary"
                          :data="tasks"
                          row-key="id"
                          empty-text="No tasks"
                >
                    <el-table-column v-for="column in columns"
                                     :key="column.name"
                                     :sortable="column.sortable"
                                     :width="column.width || 'auto'"
                                     :min-width="column.minWidth || '100px'"
                                     :prop="column.name"
                                     :formatter="column.formatter"
                                     :label="$t(column.text)"/>
                    <el-table-column
                            :min-width="75"
                            :width="75"
                            align="center"
                            fixed="right"
                            class-name="td-actions">
                        <template slot-scope="props">
                            <p-button round type="success" size="sm" icon @click="taskDetails(props.row)">
                                <i class="fa fa-eye"/>
                            </p-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <task-dialog v-model="task" :show="showTaskDialog" :handleClose="() => {this.showTaskDialog = false}" :append-to-body="true"/>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { Table, TableColumn } from 'element-ui'
  import { Input } from 'element-ui'
  import Modal from '../../Dashboard/Components/BasicModal'
  import TaskDialog from '../../Dashboard/Components/TaskDialog'
  import concat from 'lodash/concat'
  import { mapActions } from 'vuex'

  Vue.use(Table)
  Vue.use(TableColumn)

  export default {
    name: 'TaskList',
    components: {
      [Input.name]: Input,
      Modal,
      TaskDialog
    },
    props: {
      value: Object,
      height: Number
    },
    computed: {
      tasks: function () {
        if (this.value) {
          return concat(this.value.createdTasks, this.value.completedTasks)
        } else {
          return []
        }
      }
    },
    data () {
      return {
        task: null,
        showNoteDialog: false,
        showTaskDialog: false,
        columns: [
          { name: 'title', text: 'Task', sortable: false, align: 'left' }
        ],
      }
    },
    methods: {
      ...mapActions('user/waveline', ['setNote']),
      taskDetails: function (task) {
        this.task = task
        this.showTaskDialog = true
      }
    }
  }
</script>
<style lang="scss">
    .task-list {
        top: 5px;
        margin: 0;
    }

    .task-row {
        display: flex;
        align-items: center;
    }

    .el-table .cell {
      word-break: normal;
    }
</style>
